import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F90C {
  f90c_01: string;        // 面試代號 (PK, max 8 chars)
  f90c_11: string;        // 姓名
  f90c_12: string;        // 身份證號
  f90c_13: string | null; // 出生日期
  f90c_14: number;        // 婚姻狀況
  f90c_15: number;        // 性別
  f90c_16: string;        // 最後就讀學校
  f90c_17: string;        // 科系
  f90c_18: string;        // 畢業年度
  f90c_19: string;        // 聯絡電話
  f90c_20: string;        // 行動電話
  f90c_25: string;        // 聯絡地址
  f90c_26: string;        // 戶籍地址
  f90c_27: string;        // 緊急聯絡人
  f90c_28: string;        // 緊急聯絡電話
  f90c_29: string;        // 籍貫
  f90c_31: string | null; // 應聘日期
  f90c_32: string;        // 應聘部門代號
  f90c_33: string;        // 應聘職稱代號
  f90c_35: string | null; // 可開始上班日
  f90c_42: string;        // 身高(CM)
  f90c_43: string;        // 體重(KG)
  f90c_53: string;        // 期望待遇(/月)
  f90c_55: string;        // 英文名字
  f90c_91: string;        // 建立人員
  f90c_92: string | null; // 建立/修改日期
  f90c_93: string;        // 修改人員
}

export interface CreateRequest {
  f90c_01: string;
  f90c_11: string;
  f90c_12?: string;
  f90c_13?: string | null;
  f90c_14?: number;
  f90c_15?: number;
  f90c_16?: string;
  f90c_17?: string;
  f90c_18?: string;
  f90c_19?: string;
  f90c_20?: string;
  f90c_25?: string;
  f90c_26?: string;
  f90c_27?: string;
  f90c_28?: string;
  f90c_29?: string;
  f90c_31?: string | null;
  f90c_32?: string;
  f90c_33?: string;
  f90c_35?: string | null;
  f90c_42?: string;
  f90c_43?: string;
  f90c_53?: string;
  f90c_55?: string;
}

export interface UpdateRequest {
  f90c_11: string;
  f90c_12?: string;
  f90c_13?: string | null;
  f90c_14?: number;
  f90c_15?: number;
  f90c_16?: string;
  f90c_17?: string;
  f90c_18?: string;
  f90c_19?: string;
  f90c_20?: string;
  f90c_25?: string;
  f90c_26?: string;
  f90c_27?: string;
  f90c_28?: string;
  f90c_29?: string;
  f90c_31?: string | null;
  f90c_32?: string;
  f90c_33?: string;
  f90c_35?: string | null;
  f90c_42?: string;
  f90c_43?: string;
  f90c_53?: string;
  f90c_55?: string;
}

export interface ListResponse {
  data: F90C[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pw910cf1Api = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/pw910cf1', { params });
    return res.data;
  },

  async get(code: string): Promise<F90C> {
    const res = await apiClient.get(`/api/pw910cf1/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F90C> {
    const res = await apiClient.post('/api/pw910cf1', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F90C> {
    const res = await apiClient.put(`/api/pw910cf1/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/pw910cf1/${encodeURIComponent(code)}`);
  },
};
